import { render, staticRenderFns } from "./pg_information.vue?vue&type=template&id=9dcf974e"
import script from "./pg_information.vue?vue&type=script&lang=js"
export * from "./pg_information.vue?vue&type=script&lang=js"
import style0 from "./pg_information.vue?vue&type=style&index=0&id=9dcf974e&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports